var _a, _b;
import { css } from '@emotion/react';
import { mediaQuery } from '../helpers';
import { theme } from '../theme';
import { tokens } from '../tokens';
import { toastEnter, toastExit } from './keyframes';
var toastListStaticStyle = css((_a = {
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        padding: "0 ".concat(tokens.spacing.medium),
        pointerEvents: 'none',
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: tokens.zIndex.toast
    },
    _a[mediaQuery.aboveSmall] = {
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'auto',
    },
    _a));
export function toastsListStyle(_a) {
    var offset = _a.offset;
    return [
        toastListStaticStyle,
        css({
            paddingTop: offset,
        }),
    ];
}
var animatedWrapperStaticStyle = css({
    listStyle: 'none',
    opacity: 0,
    transform: 'scale3d(0.5, 0.5, 0.5)',
    transformOrigin: '50% 20%',
});
export function animatedWrapperStyle(_a) {
    var height = _a.height, isVisible = _a.isVisible;
    return [
        animatedWrapperStaticStyle,
        css({
            animation: "".concat(isVisible ? toastEnter : toastExit({ height: height }), " 500ms ").concat(isVisible
                ? 'cubic-bezier(0.2, 1, 0.4, 1)'
                : 'cubic-bezier(0.4, 1, 0.4, 0.8)', " forwards"),
            height: height,
        }),
    ];
}
export var toastStaticStyle = css((_b = {
        borderColor: theme.border.main,
        boxShadow: theme.boxShadow.thick,
        marginTop: tokens.spacing.medium,
        pointerEvents: 'all',
        userSelect: 'none',
        width: '100%'
    },
    _b[mediaQuery.aboveSmall] = {
        width: '360px',
    },
    _b));
export var titleStaticStyle = css({
    lineHeight: tokens.lineHeights.relaxed,
    margin: 0,
    padding: "".concat(tokens.spacing.xsmall, " 0"),
});
export var descriptionStaticStyle = css({
    marginBottom: 0,
    marginTop: tokens.spacing.xsmall,
});
